import { render, staticRenderFns } from "./AttnFlowList.vue?vue&type=template&id=f52c913c&"
import script from "./AttnFlowList.vue?vue&type=script&lang=js&"
export * from "./AttnFlowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports